import {CommonModule} from "@angular/common";
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from "moment";


@Pipe({ name: 'formatHHMMSS' })
export class ConvertTimePipe implements PipeTransform {
  /** * * @param value * @returns {string} */
  transform(value: any): string {
    var decimalTimeString: any = Number(value);
    var decimalTime = parseFloat(decimalTimeString);
    decimalTime = decimalTime * 60 * 60;
    var hours: any = Math.floor((decimalTime / (60 * 60)));
    decimalTime = decimalTime - (hours * 60 * 60);
    var minutes: any = Math.floor((decimalTime / 60));
    decimalTime = decimalTime - (minutes * 60);
    var seconds: any = Math.round(decimalTime);

    if (minutes >= 60) {
      hours = hours + 1;
      minutes = 0
    }

    if (seconds >= 60) {
      minutes = minutes + 1;
      seconds = 0
    }

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return minutes + ":" + seconds
  }
}